// extracted by mini-css-extract-plugin
export var box = "ContentWithItems-module--box--6f692";
export var box_md = "ContentWithItems-module--box_md--7511a";
export var box_xmd = "ContentWithItems-module--box_xmd--1dcb3";
export var box_flex = "ContentWithItems-module--box_flex--454b8";
export var box_lg = "ContentWithItems-module--box_lg--ccbbc";
export var box_sm = "ContentWithItems-module--box_sm--d4da4";
export var box_outer = "ContentWithItems-module--box_outer--91bd2";
export var box_whiteBg = "ContentWithItems-module--box_white-bg--ba067";
export var box_noMarginBottom = "ContentWithItems-module--box_no-margin-bottom--826de";
export var box_noPadding = "ContentWithItems-module--box_no-padding--40c06";
export var box_outerGray = "ContentWithItems-module--box_outer-gray--8f571";
export var box_dark = "ContentWithItems-module--box_dark--a95aa";
export var box_zIndex = "ContentWithItems-module--box_z-index--1af3f";
export var box_zIndex6 = "ContentWithItems-module--box_z-index-6--a12b8";
export var box_eventsWithLine = "ContentWithItems-module--box_events-with-line--75d0a";
export var box_featuresAo = "ContentWithItems-module--box_features-ao--fb7cc";
export var box_verticalPaddings = "ContentWithItems-module--box_vertical-paddings--02c89";
export var clearP = "ContentWithItems-module--clearP--65048";
export var clearP_vc = "ContentWithItems-module--clearP_vc--82d61";
export var wrapper = "ContentWithItems-module--wrapper--db9a1";
export var layout = "ContentWithItems-module--layout--870c9";
export var fadeInAnimation = "ContentWithItems-module--fadeInAnimation--50104";
export var placeHolderShimmer = "ContentWithItems-module--placeHolderShimmer--aee05";